export const Title = ({ children }) => {
	return (
		<h1>{children}</h1>
	)
}